export enum ErrorType {
  CHUNK_LOAD_ERROR = 'chunk_load_error',
  SERVER_ERROR = 'server_error',
  UNKNOWN = 'unknown',
}

const isChunkLoadError = (error: Error): boolean => {
  const chunkErrorPatterns = [
    /Loading chunk .+ failed/i,
    /ChunkLoadError/i,
    /Failed to fetch dynamically imported module/i,
    /Importing a module script failed/i,
  ];

  const errorMessage = error?.message || String(error);
  const result = chunkErrorPatterns.some((pattern) => pattern.test(errorMessage));

  return result;
};

const isServerError = (error: Error): boolean => {
  const withStatus = error as Error & {
    status?: number;
  };

  return withStatus.status === 500;
};

export const getErrorType = (error: Error): ErrorType => {
  if (isChunkLoadError(error)) {
    return ErrorType.CHUNK_LOAD_ERROR;
  }
  if (isServerError(error)) {
    return ErrorType.SERVER_ERROR;
  }
  return ErrorType.UNKNOWN;
};

export const reloadOnError = (): void => {
  window.location.reload();
};
